import React from "react";
import {
  useTextWithPrecision,
  useTextWithPrecisionProps,
} from "@shared/hooks/text/useTextWithPrecision";

const TextWithPrecision = (props: useTextWithPrecisionProps) => (
  <>{useTextWithPrecision(props)}</>
);

export default React.memo(TextWithPrecision);
